module.exports = __webpack_public_path__ + "img/savnet-logo.e9a17616.svg";